import { Breakpoints } from '@volkswagen-onehub/components-core';
import React from 'react';

export const useCurrentBreakpoint = (): number => {
	const [breakpoint, setBreakpoint] = React.useState<number>(window.innerWidth);

	React.useEffect(() => {
		const handleResize = () => setBreakpoint(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return breakpoint;
};

export const isMobileBreakpoint = (maxBreakpoint?: Breakpoints): boolean => {
	const breakpoint = useCurrentBreakpoint();
	return breakpoint < (maxBreakpoint ?? Breakpoints.b960);
};
